import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { PACKAGE_TYPE } from '../../../../../filters/constants';
import messages from './messages';

export default {
  id: PACKAGE_TYPE,
  displayName: <FormattedMessage {...messages.package} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'PackageTypeId',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  allowsMultipleSelection: true,
  shouldHideActionButtons: true,
};
